import { ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit, ViewEncapsulation, ViewRef, inject } from '@angular/core';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { ActivatedRoute, Router, RouterStateSnapshot } from '@angular/router';
import { DocumentSaveService, DocumentService, ModifiedFieldService, NavigationService } from '@formbird/services';
import { HTTP_STATUS_OK } from '@formbird/shared';
import { ModalService } from '@services/modal/modal.service';
import { ConfirmSaveChangesService } from '@services/modal/confirm-save-change.service';
import { Subscription } from 'rxjs';
import { BackgroundImageDirective } from '../../directives/background.directive';
import { FormColorDirective } from '../../directives/form-color.directive';
import { MainTemplateComponent } from '../main-template/main-template.component';
import { SharedConstants } from '@formbird/types';

@Component({
  selector: 'ft-template-view',
  templateUrl: './template-view.component.html',
  styleUrls: ['./template-view.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  imports: [CdkScrollable, FormColorDirective, BackgroundImageDirective, MainTemplateComponent]
})
export class TemplateViewComponent implements OnInit, OnDestroy {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private cdr = inject(ChangeDetectorRef);
  private navigationService = inject(NavigationService);
  private modalService = inject(ModalService);
  private confirmSaveChangesService = inject(ConfirmSaveChangesService);
  private modifiedFieldService = inject(ModifiedFieldService);
  private documentSaveService = inject(DocumentSaveService);
  private documentService = inject(DocumentService);

  private subParam: Subscription;

  noNavBar = false;

  public params: any;
  public renderForm: boolean = false;
  public hideTopBar: boolean;
  public fullWindow: boolean;

  public initialized = false;

  ngOnInit() {

    this.subParam = this.route.params.subscribe(async (params: any) => {
      try {

        this.renderForm = false;
        this.params = params;
        
        console.log('Route changes detected: ', params);

        const { id, templateId } = params;
        let {document, template, templateReturnStatus, templateError } = await this.documentService.getTemplateAndDocument(id, templateId);
        if ( templateReturnStatus !== HTTP_STATUS_OK ){
          console.error('Error getting template: ' + templateError.message ? templateError.message : templateError);
        } else if(template) {
          this.hideTopBar = template.hideTopBar;
          this.fullWindow = template.fullWindow;
          this.noNavBar = template.noNavBar;
          
          this.navigationService.setCurrentTemplate(template);

          if (document) {
            const documentId = document.documentId;
            const tplId = template.documentId;
            if (document.systemHeader.templateId !== documentId &&
              document.systemHeader.systemType !== SharedConstants.SYSTEM_TYPE_TEMPLATE) {
              this.documentService.setAltTemplateInfo(documentId, tplId);
            }
          }
        }

        console.log('Data loaded from route changes.');

      } catch (error) {
        console.log(error);
      } finally {
        this.renderForm = true;
        this.initialized = true;
        this.detectChanges();
      }

    });
  }

  detectChanges() {
    if (!(this.cdr as ViewRef).destroyed) {
      this.cdr.detectChanges();
    }
  }

  ngOnDestroy() {
    this.subParam.unsubscribe();
  }

  canDeactivate(nextState: RouterStateSnapshot) {
    return this.confirmSaveChangesService.confirm({
      nextUrl: nextState.url
    });
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) {
    if (this.modifiedFieldService.isDirty()) {
      $event.returnValue = true;
    }
  }

}
